// extracted by mini-css-extract-plugin
module.exports = {"container":"BoxInlineListItem_container__2Wqrv"};